export const updateCache = (cache, id, newData, typename) => {
    const cacheId = cache.identify({
        __typename: typename,
        id,
    });

    if (cacheId) {
        Object.keys(newData).forEach((key) => {
            cache.modify({
                id: cacheId,
                fields: {
                    [key]: () => newData[key],
                },
            });
        });
    }
};

export const clearCache = (cache, fieldName) => {
    cache.evict({ fieldName });
    cache.gc();
};
